module.exports = __webpack_public_path__ + "static/media/quill.d2ea47fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/quill.svg
// module id = 23
// module chunks = 0